import { CountInterface, DataWithPaginationInterface } from 'shared/types/pagination-interface'

export type SmsTemplateId = number & { __brand: 'SmsTemplateId' }

export enum SenderTypeEnum {
  PhoneNumber = 'PHONE_NUMBER',
  Alphanumeric = 'ALPHANUMERIC',
  MessageService = 'MESSAGE_SERVICE',
}

export interface SmsTemplateInterface {
  id: SmsTemplateId
  name: string
  senderType: SenderTypeEnum
  phoneNumber: string | null
  alphanumericSender: string | null
  messageServiceSid: string | null
  content: string

  userId?: number
  sentMessagesCount?: number
  deliveredMessagesCount?: number
  failedMessagesCount?: number
  lastSentAt?: string | null
}

export interface SmsTemplateCreateInterface {
  name: string
  senderType: SenderTypeEnum
  content: string
  phoneNumber: string | null
  alphanumericSender: string | null
  messageServiceSid: string | null
}

export interface SmsTemplateUpdateInterface {
  id: SmsTemplateId
  name: string
  content: string
  senderType: SenderTypeEnum
  phoneNumber: string | null
  alphanumericSender: string | null
  messageServiceSid: string | null
}

export interface SmsTemplateListResponse
  extends DataWithPaginationInterface<SmsTemplateInterface> {}

export interface SmsTemplateCountResponse extends CountInterface {
  limitExceeded: boolean
}

export interface SmsTemplateFilterInterface {
  search: string
}

export interface SmsTemplateListAllInterface
  extends Array<Pick<SmsTemplateInterface, 'id' | 'name'>> {}
